import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../app/hooks';
import { TUserloggedInDetails } from '../types';
import { setLoggedInUserDetails } from '../features/authentication/authSlice';

interface iFnArgs {
  verifyPhoneFn: () => void;
  successFn: () => void;
  token: string;
  userDetails: TUserloggedInDetails;
}
const useOnSuccessfulLogin = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const successfulLoginAction = ({ successFn, token, userDetails, verifyPhoneFn }: iFnArgs) => {
    localStorage.setItem('login-token', token);
    localStorage.setItem('paymentToken', token);
    localStorage.setItem('login-email', userDetails?.email);
    localStorage.setItem('login-phone', userDetails?.phoneNumber);
    localStorage.setItem('sessId', userDetails?.sessId ?? '');
    localStorage.setItem('2fa-enabled', userDetails?.is2FAEnabled);

    localStorage.removeItem('signup-token');
    delete userDetails.token;
    dispatch(setLoggedInUserDetails(userDetails));

    if (!userDetails?.isSecurityQuestion) {
      navigate(`/set-security-questions?token=${token}&source=${userDetails?.email}&action=login`);
    }
    if (userDetails?.isSecurityQuestion && userDetails?.ageOfBusiness === 'yet to start') {
      navigate('/about/business');
    }
    if (
      userDetails?.isSecurityQuestion &&
      userDetails?.ageOfBusiness !== 'yet to start' &&
      !userDetails?.isPhoneNumberVerified
    ) {
      verifyPhoneFn();
    } else if (
      userDetails?.isSecurityQuestion &&
      userDetails?.isPhoneNumberVerified &&
      userDetails?.ageOfBusiness !== 'yet to start'
    ) {
      navigate('/dashboard');
      successFn();
    }
  };

  return { successfulLoginAction };
};

export default useOnSuccessfulLogin;
